var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMvp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#2B2A29"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.871 27.0975L20.8968 31.1221M16.871 27.0975C16.871 27.0975 19.2479 21.158 22.6312 17.0363M16.871 27.0975C8.11652 24.9092 15.9819 17.0363 22.6312 17.0363M20.8968 31.1221C20.8968 31.1221 26.8382 28.7459 30.9613 25.3637M20.8968 31.1221C23.0858 39.872 30.9613 32.0108 30.9613 25.3637M22.6312 17.0363C26.0532 12.8676 31.6943 10.9995 37 10.9995C37 16.3035 35.1314 21.9411 30.9613 25.3637M28.1097 19.731L29.2956 18.5455M13.1286 31.6687C11.5317 33.0119 11 36.9995 11 36.9995C11 36.9995 14.9788 36.4663 16.3191 34.8665C17.0739 33.9711 17.0639 32.596 16.2235 31.7643C15.808 31.3739 15.2641 31.1487 14.6942 31.1311C14.1242 31.1135 13.5674 31.3047 13.1286 31.6687Z",
    stroke: "#FFED00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMvp);
export default __webpack_public_path__ + "static/media/mvp.34e14b02a89b41aaa5766c4d3ee62b25.svg";
export { ForwardRef as ReactComponent };